import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import SSL_NETWORK from "Components/AboutSSL/SSLNetwork";
import Introduction from "Components/AboutSSL/Introduction";
import SSL_JOURNEY from "Components/AboutSSL/SSLJourney";

import Artists from "Components/Artists";
import ArtistsDetail from "Components/Artists/ArtistsDetail";
import Contact from "Components/Contact";
import Discography from "Components/Discography";
import DiscographyDetail from "Components/DiscographyDetail";
import RADAR from "Components/55RADAR/index";
import Footer from "Components/Footer";
import Header from "Components/Header";
import Home from "Components/Home";
import Label from "Components/Label";
import Project from "Components/Project";
import Merchandise from "Components/Merchandise";
import News from "Components/News";
import Magazine from "Components/News/Magazine";
import Culture from "Components/Crew/SSLCulture";
import Carreer from "Components/Crew/SSLCarreer";
import CarreerDetail from "Components/Crew/SSLCarreer/CarreerDetail/index";
import PartnerDetail from "Components/AboutSSL/SSLNetwork/PartnerDetail/index";

import "i18n";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./App.scss";
import useWindowDimensions from "Hook/useWindowDimensions.jsx";
// App.js
function RoutesWrapper({ width }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <>
      <Header />
      <Routes>
        <Route path="/">
          {/* <Route index element={width < 991 ? <HomeMobile /> : <Home />} /> */}
          <Route index element={<Home />} />
          <Route path="ssl-network" element={<SSL_NETWORK />} />
          <Route path="introduction" element={<Introduction />} />
          <Route path="ssl-journey" element={<SSL_JOURNEY />} />
          <Route path="ssl-network/:id" element={<PartnerDetail />} />
          <Route path="artists">
            <Route index element={<Artists />} />
            <Route path=":name" index element={<ArtistsDetail />} />
          </Route>
          <Route path="discography">
            <Route index element={<Discography />} />
            <Route path="detail/:id" element={<DiscographyDetail />} />
          </Route>
          <Route path="/:project" element={<RADAR />} />
          <Route path="spacespeakers-label" element={<Label />} />
          <Route path="project">
            <Route index element={<Project />} />
          </Route>
          <Route path="contact" element={<Contact />} />
          <Route path="merchandise" element={<Merchandise />} />
          <Route path="ssl-news" element={<News />} />
          <Route path="ssl-magazine" element={<Magazine />} />

          <Route path="ssl-culture" element={<Culture />} />
          <Route path="ssl-carreer" element={<Carreer />} />
          <Route path="ssl-carreer/:id" element={<CarreerDetail />} />
        </Route>
      </Routes>
      {!isHome && <Footer />}
    </>
  );
}

function App() {
  const client = new ApolloClient({
    cache: new InMemoryCache(),
    uri: "https://api.appfast.io/v8",
  });

  const { width } = useWindowDimensions();

  return (
    <ApolloProvider client={client}>
      <Router>
        <div className="App">
          <RoutesWrapper width={width} />
        </div>
      </Router>
    </ApolloProvider>
  );
}
export default App;
